(function () {
  'use strict';

  var READY = 'rr-section-ready';
  var LOADING = 'rr-section-loading';
  var TIMEOUT_MS = 3000;
  var ROOT = '#PageContainer';
  var VIEW_MARGIN = 120;

  function nearViewport(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom >= -VIEW_MARGIN && rect.top <= vh + VIEW_MARGIN;
  }

  function isPendingMedia(el) {
    if (!el) return false;
    if (el.tagName === 'IMG') {
      if (el.classList.contains('lazyload') || el.classList.contains('lazyloading')) {
        return !el.classList.contains('lazyloaded');
      }
      return !(el.complete && el.naturalWidth > 0);
    }
    if (el.classList && (el.classList.contains('lazyload') || el.classList.contains('lazyloading'))) {
      return !el.classList.contains('lazyloaded');
    }
    if (el.tagName === 'VIDEO') {
      return el.readyState < 2;
    }
    return false;
  }

  // display:none elements (e.g. hide-sm images) never load; skip them so they don't hold the skeleton
  function isRendered(el) {
    return el.getClientRects().length > 0;
  }

  function sectionPendingMedia(section, onlyNear) {
    var nodes = section.querySelectorAll(
      'img.lazyload, img.lazyloading, img[loading="lazy"], .grid_img.lazyload, .grid_img.lazyloading, .ssimg.lazyload, .ssimg.lazyloading, video'
    );
    var pending = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!isPendingMedia(el)) continue;
      if (!isRendered(el)) continue;
      if (onlyNear && !nearViewport(el)) continue;
      pending.push(el);
    }
    return pending;
  }

  // Inactive tab panels carry [hidden] and are only initialized on click
  function sectionPendingSwipers(section) {
    var nodes = section.querySelectorAll('.swiper:not(.swiper-initialized)');
    var pending = [];
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (!el.querySelector('.swiper-slide')) continue;
      if (el.closest('[hidden]')) continue;
      if (!isRendered(el) || !nearViewport(el)) continue;
      pending.push(el);
    }
    return pending;
  }

  function markReady(section) {
    if (!section || section.classList.contains(READY)) return;
    section.classList.remove(LOADING);
    section.classList.add(READY);
  }

  function bindPending(section, pending, finish, check) {
    for (var i = 0; i < pending.length; i++) {
      var el = pending[i];
      if (el.tagName === 'VIDEO') {
        el.addEventListener('loadeddata', check, { once: true });
        el.addEventListener('error', check, { once: true });
      } else if (el.tagName === 'IMG') {
        el.addEventListener('load', check, { once: true });
        el.addEventListener('error', check, { once: true });
        el.addEventListener('lazyloaded', check, { once: true });
      } else {
        el.addEventListener('lazyloaded', check, { once: true });
      }
    }

    document.addEventListener('lazyloaded', function onLazy(e) {
      if (section.classList.contains(READY)) {
        document.removeEventListener('lazyloaded', onLazy);
        return;
      }
      if (section.contains(e.target)) check();
    });
  }

  function watchVisibleMedia(section) {
    if (!section || section.classList.contains(READY)) return;

    section.classList.add(LOADING);

    var pending = sectionPendingMedia(section, true);
    var swipers = sectionPendingSwipers(section);
    if (!pending.length && !swipers.length) {
      markReady(section);
      return;
    }

    var done = false;
    var swiperObserver = null;
    var timer = setTimeout(function () {
      finish();
    }, TIMEOUT_MS);

    function finish() {
      if (done) return;
      done = true;
      clearTimeout(timer);
      if (swiperObserver) swiperObserver.disconnect();
      markReady(section);
    }

    function check() {
      if (done) return;
      if (!sectionPendingMedia(section, true).length && !sectionPendingSwipers(section).length) finish();
    }

    bindPending(section, pending, finish, check);

    if (swipers.length && 'MutationObserver' in window) {
      swiperObserver = new MutationObserver(check);
      for (var i = 0; i < swipers.length; i++) {
        swiperObserver.observe(swipers[i], { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  function watchSection(section) {
    if (!section || section.classList.contains(READY)) return;

    section.classList.add(LOADING);

    // Below-fold: reveal text quickly; image skeletons still pulse via CSS on .lazyload
    if (!nearViewport(section)) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(
          function (entries) {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            if (!section.classList.contains(READY)) {
              watchVisibleMedia(section);
            }
          },
          { rootMargin: VIEW_MARGIN + 'px' }
        );
        io.observe(section);
        // Soft fallback so titles aren't stuck if observer never fires
        setTimeout(function () {
          if (!section.classList.contains(READY) && !nearViewport(section)) {
            markReady(section);
          }
        }, TIMEOUT_MS);
      } else {
        markReady(section);
      }
      return;
    }

    watchVisibleMedia(section);
  }

  function scan(root) {
    var scope = root || document.querySelector(ROOT);
    if (!scope) return;
    var sections = scope.querySelectorAll('.shopify-section');
    for (var i = 0; i < sections.length; i++) {
      watchSection(sections[i]);
    }
  }

  function refreshSection(section) {
    if (!section) return;
    section.classList.remove(READY);
    watchSection(section);
  }

  function init() {
    scan();

    document.addEventListener('shopify:section:load', function (e) {
      var section =
        e.target && e.target.classList && e.target.classList.contains('shopify-section')
          ? e.target
          : document.getElementById('shopify-section-' + (e.detail && e.detail.sectionId));
      refreshSection(section);
    });

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type !== 'childList' || !m.addedNodes.length) continue;
        var target = m.target;
        if (!target || !target.closest) continue;
        var host =
          target.closest('product-recommendations') ||
          target.closest('product-complementary') ||
          (target.tagName &&
            (target.tagName.toLowerCase() === 'product-recommendations' ||
              target.tagName.toLowerCase() === 'product-complementary') &&
            target);
        if (!host) continue;
        var section = host.closest('.shopify-section');
        if (section) refreshSection(section);
      }
    });

    var page = document.querySelector(ROOT);
    if (page) observer.observe(page, { childList: true, subtree: true });

    // Back/forward cache restore: content is already laid out, never show skeletons again
    window.addEventListener('pageshow', function (e) {
      if (!e.persisted) return;
      var scope = document.querySelector(ROOT);
      if (!scope) return;
      var sections = scope.querySelectorAll('.shopify-section');
      for (var i = 0; i < sections.length; i++) markReady(sections[i]);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.rrSectionSkeletons = { scan: scan, refreshSection: refreshSection, markReady: markReady };
})();
